<template>
  <!--==================
    component shows all landing places to visit pages created (admin)
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="mb-2 ml-3">
      <a class="btn btn-sm btn-primary" href="/dashboard/places-to-visit/new-page" target="_blank"
        >Add Places To Visit Page</a
      >
    </div>
    <nav>
      <div class="nav nav-tabs flex-row mb-4" id="nav-tab" role="tablist">
        <a
          class="nav-item nav-link active"
          id="nav-published-tab"
          data-toggle="tab"
          href="#nav-published"
          role="tab"
          aria-controls="nav-published"
          aria-selected="true"
          data-selector="published"
        >
          Published <span class="badge badge-light font-weight-bold">{{ publishedPages.length }}</span>
        </a>
        <a
          class="nav-item nav-link"
          id="nav-unpublished-tab"
          data-toggle="tab"
          href="#nav-unpublished"
          role="tab"
          aria-controls="nav-unpublished"
          aria-selected="false"
          data-selector="unpublished"
        >
          Unpublished <span class="badge badge-light font-weight-bold">{{ unpublishedPages.length }}</span>
        </a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <!-- published page -->
      <div class="tab-pane fade show active" id="nav-published" role="tabpanel" aria-labelledby="nav-published-tab">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-nowrap card-table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Page Title</th>
                  <th scope="col">Page Slug</th>
                  <th scope="col">Updated Date</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(page, index) in publishedPages" :key="page.id" :data-id="page.id">
                  <td :id="'row-' + page.id">{{ index + 1 }}</td>
                  <td class="font-weight-bold">
                    <a class="d-block pb-2" :href="placesURL + page.slug" target="_blank">{{ page.title }}</a>
                  </td>
                  <td>
                    <p>{{ page.slug }}</p>
                  </td>
                  <td>
                    <span class="small text-muted">
                      <i class="icofont-clock-time"></i>
                      {{ page.updatedAt | utcDateToLocalDate("yyyy-mm-dd HH:MM:ss") }}
                    </span>
                  </td>
                  <td class="text-right">
                    <div class="dropdown">
                      <button
                        class="btn btn-sm btn-primary ml-2 mr-2"
                        role="button"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="icofont-listine-dots"></i>
                      </button>

                      <div class="dropdown-menu">
                        <button class="dropdown-item"><i class="icofont-eye-alt"></i> View</button>
                        <button class="dropdown-item" @click="updatePage($event)" :data-id="page.id">
                          <i class="icofont-edit"></i> Edit
                        </button>
                        <button
                          class="dropdown-item"
                          @click="unpublishStatus($event)"
                          :data-id="page.id"
                          :data-index="index"
                        >
                          <i class="icofont-eye-blocked"></i> Unpublish
                        </button>
                        <button
                          class="dropdown-item"
                          @click="deletePage($event)"
                          :data-id="page.id"
                          :data-index="index"
                          data-page="published"
                        >
                          <i class="icofont-bin"></i> Delete
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- unpublished page -->
      <div class="tab-pane fade" id="nav-unpublished" role="tabpanel" aria-labelledby="nav-unpublished-tab">
        <div class="card">
          <div class="table-responsive">
            <table class="table table-sm table-nowrap card-table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Page Title</th>
                  <th scope="col">Page Slug</th>
                  <th scope="col">Updated Date</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(page, index) in unpublishedPages" :key="page.id" :data-id="page.id">
                  <td :id="'row-' + page.id">{{ index + 1 }}</td>
                  <td class="font-weight-bold">
                    <a class="d-block pb-2" :href="'#'" target="_blank">{{ page.title }}</a>
                  </td>
                  <td>
                    <p>{{ page.slug }}</p>
                  </td>
                  <td>
                    <span class="small text-muted">
                      <i class="icofont-clock-time"></i>
                      {{ page.updatedAt | utcDateToLocalDate("yyyy-mm-dd HH:MM:ss") }}
                    </span>
                  </td>
                  <td class="text-right">
                    <button
                      @click="publishStatus($event)"
                      class="btn btn-sm btn-success mr-2"
                      :data-id="page.id"
                      :data-index="index"
                    >
                      Publish
                    </button>
                    <button @click="updatePage($event)" class="btn btn-sm btn-primary ml-2 mr-2" :data-id="page.id">
                      Edit
                    </button>
                    <button
                      @click="deletePage($event)"
                      class="btn btn-sm btn-danger ml-2"
                      :data-id="page.id"
                      :data-index="index"
                      data-page="unpublished"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LandingPlaces",

  computed: {
    ...mapGetters(["publishedPlacestovisitPosts", "unpublishedPlacestovisitPosts"]),

    publishedPages() {
      return this.publishedPlacestovisitPosts;
    },

    unpublishedPages() {
      return this.unpublishedPlacestovisitPosts;
    },
  },

  data() {
    return {
      placesURL: process.env.VUE_APP_PLACES_URL,
    }
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchPublishedPlacestovisitPosts();
      await this.fetchUnpublishedPlacestovisitPosts();

      this.hideBarLoading();
    });
  },

  methods: {
    ...mapActions([
      "hideBarLoading",
      "fetchPublishedPlacestovisitPosts",
      "fetchUnpublishedPlacestovisitPosts",
      "publishPlacestovisitPost",
      "deletePlacestovisitPost",
    ]),

    async publishStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.publishPlacestovisitPost({ id, publish: true });
      this.fetchPublishedPlacestovisitPosts();
    },

    async unpublishStatus(e) {
      let id = e.target.getAttribute("data-id");

      await this.publishPlacestovisitPost({ id, publish: false });
      this.fetchUnpublishedPlacestovisitPosts();
    },

    deletePage(e) {
      let id = e.target.getAttribute("data-id");
      let page = e.target.getAttribute("data-page");
      let dP = this;

      $.confirm({
        title: "",
        content: "Are you sure want to delete this page?",
        buttons: {
          confirm: async () => {
            await dP.deletePlacestovisitPost(id);

            if (page == "unpublished") {
              dP.fetchUnpublishedPlacestovisitPosts();
            } else {
              dP.fetchPublishedPlacestovisitPosts();
            }
          },
          cancel: () => {},
        },
      });
    },

    updatePage(e) {
      let id = e.target.getAttribute("data-id");
      window.open("/dashboard/places-to-visit/page/edit/" + id, "_blank");
    },
  },
};
</script>
